// src/components/pages/Produto/tabs/CabecalhoTabPanel.jsx
import React from 'react';

import formStyles from '../../../form/Form.module.css';

// componentes do seu projeto (ajuste paths conforme seu projeto)
import TextArea from '../../../form/TextArea';

/**
 * Painel modo produção do Produto
 * - Burro: só renderiza
 * - Toda lógica fica no Form/useModule
 */
const ModoProducaoTabPanel = ({
    module,

    //parametros
    profile,
}) => {
    const { dados } = module.state;
    const { change: onChange } = module.actions;

    const uiTab = profile.uiTabs.modoProducao;

    return (
        <div>
            <div className={formStyles.preview_bandeira}>
                <h4>{uiTab?.labels?.grid}</h4>
            </div>
            <TextArea
                text="Instruções de Produção"
                type="text"
                name="modoProducao"
                placeholder="Detalhe a forma de produzir"
                title={`Digite detalhadamente passo-a-passo a forma de produzir o produto`}
                handleOnChange={onChange}
                value={dados.modoProducao || ''}
                textAlign="left"
                linhas="20"
                colunas="120"
                fontSize="25px"
                fontWeight="bold"
                padding="12px"
            />
        </div>
    );
};
export default React.memo(ModoProducaoTabPanel);
